import { Select } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'

import { Item } from '../../Cfmp.styles'
import { selectFieldShape } from './CfmpForm.propTypes'

/**
 * The CfmpFormJustification component.
 */
export const CfmpFormJustification = ({
  isDisabled = false,
  isSourcesLoading = false,
  reasonType
}) => {
  const { errorText, input, source } = reasonType

  return (
    <Item size={12}>
      <Select
        disabled={Boolean(source.error) || isDisabled}
        error={errorText}
        label="Causal de la compra"
        loading={isSourcesLoading}
        onChange={input.onChange}
        options={source.data}
        placeholder={source.error ? 'Sin causal disponible' : 'Seleccione una causal...'}
        value={input.value}
      />
    </Item>
  )
}

CfmpFormJustification.propTypes = {
  isDisabled: PropTypes.bool,
  isSourcesLoading: PropTypes.bool,
  reasonType: selectFieldShape.isRequired
}
